export const VOUCHER_ATTRIBUTES = [1, 4, 5, 8, 9, 26, 53, 78, 117, 119, 120, 121, 168, 189, 190, 205];
